var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3611_161",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3611_161",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACgklEQVR4nO3bv2sTYRzH8c9zSShVW7E/BvvDTXAQ3BS3Tjq4dNJZpP0b9E9w0K4WoQ4O/gk6KIhLETo4OFSKg7Wxm6ARu7T5OrRFjTTNtXf5BPN+LRcId/dw7z5HLk8qAQAAAADQT1IZB51Yqk9Hc3tBoWtSGirjHJ2LhpRepqxy78udyQ/esfyr8AATS/Xp2Nl5J2mk6GMf09dM2aX63NSGeyB/yoo+YDS3F9R7F1+SRkLx0D2IVoUH2L3t9KaIuO4eQ6viA9jv+W0kDbuH0KqEAMiDAGYEMOv4Y+jlN99uRMSilCbLHJBf2oiI+ZWZ08+7cbaOZ0BEevT/X3xJiqmUtNits3ELMssxA2JeSj31FFmSz2pqvlsny/1VxNnH61HGQHrF5ty5Ur4fOwi3IDMCmBHAjABmBDAjgBkBzKpFH/DH8tu275+6eqWn9x+bvR/N6oCiUlNktd1tyqSUKVJFSvuPCWl/01DSKym721i6mXvNmRlwfEMKzUqxPHj72XTenQlQlNCZWqo8yLsbAQp0lDVnAhQr95ozAcwIYEYAM9YDWmx9WtHJ8XGdGB3VwPCwaoODStnvv9O1py/2XqW/NvsvGk9u5bqmzAAzApgRwIwAZgQwI4AZAcxYD2hRfb+mreq6fh66HlAMZoAZAcwIYEYAMwKYEcCMAGasB7RgPaDPEMCMAGYEMCOAGQHMCGCWez1g8+P3MsbRM8ZWWQ/oKwQwI4AZAcwIYEYAMwKYFf67IK2+bv/+hZmj7VfUcQ7ab8/2xfMdrgcUgxlgRgAzApgRwIwAZgQwI4BZ8c8Bh3zOLt0xz8//B/QZApgRwIwAZgQwI4AZAQAAAAAAQBf9AsbNn2svHZYAAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsRight);
export default __webpack_public_path__ + "static/media/buildings-right.dff81c72667302d9e3b731e8e45b1c63.svg";
export { ForwardRef as ReactComponent };